import { useState } from "react";
import { addDays, format } from "date-fns";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { useAuth } from "@/context/AuthContext";
import { Field, SpacePicker, SubmitRow } from "@/components/forms/Fields";
import { StatusPicker } from "@/components/StatusPicker";

const day = (d) => format(d, "yyyy-MM-dd");

export const ProjectForm = ({ item, defaults, onDone }) => {
  const { user } = useAuth();
  const { space, run } = useApp();
  const p = item || {};
  const [f, setF] = useState({
    title: p.title || "", description: p.description || "",
    space: p.space || defaults.space || (space !== "all" ? space : user.username),
    start_date: p.start_date || day(new Date()), end_date: p.end_date || day(addDays(new Date(), 7)),
    status: p.status || "active",
  });
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v?.target ? v.target.value : v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const payload = { ...f, start_date: f.start_date || null, end_date: f.end_date || null };
    const ok = await run(() => (item ? api.patch(`/projects/${item.id}`, payload) : api.post("/projects", payload)), item ? "Project updated" : "Project created");
    setBusy(false);
    if (ok) onDone();
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="project-form">
      <Field label="Project name">
        <Input autoFocus value={f.title} onChange={set("title")} placeholder="Trademark filing for Brand Y" required data-testid="project-title-input" className="h-11" />
      </Field>
      <Field label="Description (optional)">
        <Textarea value={f.description} onChange={set("description")} rows={3} placeholder="What's involved?" data-testid="project-description-input" />
      </Field>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Starts"><Input type="date" value={f.start_date} onChange={set("start_date")} className="font-mono" data-testid="project-start-input" /></Field>
        <Field label="Due"><Input type="date" value={f.end_date} onChange={set("end_date")} className="font-mono" data-testid="project-end-input" /></Field>
      </div>
      <Field label="Status"><StatusPicker value={f.status} onChange={set("status")} /></Field>
      <Field label="Whose space"><SpacePicker value={f.space} onChange={set("space")} /></Field>
      <SubmitRow busy={busy} label={item ? "Save project" : "Create project"} onCancel={onDone} testid="project-submit-button" />
    </form>
  );
};
